<template>
	<component :is="tag" draggable="true" @drop.stop="drop" @dragover.stop="dragover" @dragenter="dragenter" @dragleave="dragleave">
		<slot />
	</component>
</template>

<script>
	export default {
		data() {
			return {
				type: null
			};
		},
		props: {
			tag: {
				type: String,
				default: 'div'
			},
			accepts: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			drop(e) {
				console.log('drop', e.dataTransfer.getData(this.type));

				this.$emit('drop', this.type, JSON.parse(e.dataTransfer.getData(this.type)));
			},
			dragenter(e) {
				console.log('enter', e);
			},
			dragleave(e) {
				console.log('leave', e);
			},
			dragover(e) {
				//console.log('type', e.dataTransfer.items);
				//console.log('type', e.dataTransfer.items[0].type);

				for (var key in e.dataTransfer.items) {
					if (this.accepts.indexOf(e.dataTransfer.items[key].type) > -1) {
						this.type = e.dataTransfer.items[key].type;
						e.preventDefault();
						return;
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>